import { useSelector } from 'react-redux'

import {
  selectFortnoxStatusFetched,
  selectFortnoxTenantStatus,
  selectHasConfigurableIntegrations,
  selectIntegrations,
  selectIntegrationsFetched
} from 'redux/selectors/Integrations'

export const useIntegrations = () => {
  return useSelector(selectIntegrations)
}

export const useHasConfigurableIntegrations = () => {
  return useSelector(selectHasConfigurableIntegrations)
}

export const useIntegrationsFetched = () => {
  return useSelector(selectIntegrationsFetched)
}

export const useFortnoxTenantStatus = () => {
  return useSelector(selectFortnoxTenantStatus)
}

export const useFortnoxStatusFetched = () => {
  return useSelector(selectFortnoxStatusFetched)
}
